export const orderMethods = {
    uber_delivery: 'uber_delivery',
    doordash_delivery: 'doordash_delivery',
    delivery: 'delivery',
    pickup: 'pickup',
};

export const orderMethodTypes = {
    asap: 'asap',
    schedule: 'schedule'
};

export const tipTypes = {
    rate: 'rate',
    fix: 'fix'
};

export const paymentMethods = {
    any: 'any',
    cash: 'cash',
    card: 'card'
};
